<template>
  <div class="standings">
    <div class="container fluid is-desktop">
      <b-table
        :data="rowsWithWinPct"
        :selected.sync="selected"
        width="600px"
        header-class="is-centered"
        default-sort="Seed"
        sticky-header
        height="calc(100vh - 52px - 4rem)"
        hoverable
        focusable
      >
        <template slot-scope="props">
          <b-table-column
            v-for="column in columns"
            :key="column.field"
            v-bind="column"
            centered
          >
            <template v-if="column.field.endsWith('RTG') || column.field === 'winPct'">
              {{ formatValue(props.row[column.field]) }}
            </template>
            <template v-else-if="column.field === 'Team'">
              <div class="team-cell" :style="{
                color: teamAttr(props.row, 'secondary')
              }">
                <div class="logo">
                  <img :src="teamAttr(props.row, 'logo')" width="64px" />
                </div>
                <div class="has-text-left is-size-5">
                  <div>{{ teamAttr(props.row, 'city') }}</div>
                  <div>{{ teamAttr(props.row, 'nickname') }}</div>
                </div>
              </div>
            </template>
            <template v-else-if="column.field === 'gb' && props.row[column.field] === 0">
              -
            </template>
            <template v-else>
              {{ props.row[column.field] }}
            </template>
          </b-table-column>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { standings } from '../../public/wnbasim-latest.json'
import { teams } from '../teams'

export default {
  name: 'Standings',
  data () {
    return {
      standings,
      teams,
      selected: null,
      leader: {},
      columns: [
        {
          field: 'Team',
          label: '',
          width: '40%',
        },
        {
          field: 'Wins',
          label: 'Wins',
          sortable: true,
          numeric: true,
        },
        {
          field: 'Losses',
          label: 'Losses',
          sortable: true,
          numeric: true,
        },
        {
          field: 'Seed',
          label: 'Seed',
          sortable: true,
          numeric: true,
        },
        {
          field: 'winPct',
          label: 'Win %',
          numeric: true,
          sortable: true,
        },
        // {
        //   field: 'gb',
        //   label: 'Games Back',
        //   sortable: true,
        //   numeric: true,
        // },
        {
          field: 'PF',
          label: 'PF',
          numeric: true,
          sortable: true,
        },
        {
          field: 'PA',
          label: 'PA',
          numeric: true,
          sortable: true,
        },
        {
          field: 'ORTG',
          label: 'Off. Rtg',
          numeric: true,
          sortable: true,
        },
        {
          field: 'DRTG',
          label: 'Def. Rtg',
          numeric: true,
          sortable: true,
        },
        {
          field: 'NetRTG',
          label: 'Net Rtg',
          numeric: true,
          sortable: true,
        },
      ],
    }
  },
  mounted () {
    const sortedStandings = [...standings].map((row) => ({
      ...row, winPct: (row.Wins / (row.Wins + row.Losses)),
    }))
    sortedStandings.sort((a, b) => b.winPct - a.winPct)
    // eslint-disable-next-line prefer-destructuring
    this.leader = sortedStandings[0]
  },
  computed: {
    rowsWithWinPct () {
      return this.standings.map((row) => ({
        ...row,
        winPct: row.Wins / (row.Wins + row.Losses),
        gb: this.gamesBack(row),
      }))
    },
    teamsByShortName () {
      const teamMap = {}
      Object.entries(teams).forEach(([, team]) => {
        teamMap[team.short] = team
      })
      return teamMap
    },
  },
  methods: {
    formatValue: (value) => value && value.toFixed(2),
    gamesBack (value) {
      const winDiff = this.leader.Wins - value.Wins
      const lossDiff = value.Losses - this.leader.Losses
      const gb = (winDiff + lossDiff) / 2
      return gb
    },
    teamAttr (row, attr) {
      return row && this.teamsByShortName[row.Team][attr]
    },
  },
}
</script>

<style lang="scss" scoped>
.standings {
  max-width: 100%;
}

/deep/ .is-invisible {
  display: none;
}

.standings {
  padding: 2rem;
  // max-width: 1024px;
  overflow-y: auto;
  width: 100%;

  @media screen and (width: 600px) {
    padding: 2rem 6rem;
  }
}

.team-cell {
  display: flex;
  flex-direction: row;

  .logo {
    padding-right: 1rem;
    min-width: 64px;
  }
}

/deep/ .b-table {
  max-height: calc(100% - 52px);

  @media screen and (width: 900px) {
    margin: 0 30%;
  }
}

/deep/ .table-wrapper {
  max-height: calc(100% - 52px);
}
</style>
